export const isClientCIS = (clientId: string ) => {
    const clientIdNumber = parseInt(clientId);
    const clienstCIS = process.env.REACT_APP_CLIENTS_CIS_OVERFLOW?.split(',').map(Number) || [];

    return (clientIdNumber < 500999 || clienstCIS.includes(clientIdNumber))
}
